import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as categoryActions from "../../redux/actions/categoryActions";
import styled from "styled-components";
const ListItem = styled.div`
  list-style:none ;
  min-width:20rem ;
  cursor: pointer;
  &:hover {
     background-color: black; 
     color: lightgray;
  }
`;
function MenuBarCategoriesContent(props) {
  const navigate = useNavigate()
  useEffect(() => {
    props.actions.getCategories();
  }, []);
  const _changeCategory=(category)=>{
    navigate('/route=search?categoryid='+category.code)
  }

  return (
    <div >
        {props.categories.filter(cat=>cat.indentation==="ItemCategory").map((cat) => {
          return (
            <ListItem onClick={()=>_changeCategory(cat)} key={cat.code}>
              <a>{cat.description.toString().toUpperCase()}</a>
            </ListItem>
          );
        })}
    </div>
  );
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getCategories: bindActionCreators(
        categoryActions.getCategories,
        dispatch
      ),
    },
  };
}

function mapStateToProps(state) {
  return {
    categories: state.categoryListReducer,
  };
}
export default connect(mapStateToProps,mapDispatchToProps)(MenuBarCategoriesContent) ;
